// alternative-components/CFOCopilot/AttentionInfoCard.tsx
import { useEffect, useState } from "react";
import { useCountry } from "@/app/services/context/CountryContext";
import { gxDashboardPendingRepairCountApi } from "@/app/apiConfig/services/customerAbstractApiLayer";
import InfoCard from "./InfoCard";

interface AttentionInfoCardProps {
  title?: string;
}

const AttentionInfoCard = ({ title }: AttentionInfoCardProps) => {
  const { selectedCountry } = useCountry();
  const currencyCode = selectedCountry?.currency?.code ?? "";

  const [countOfRepair, setCountOfRepair] = useState<number>(0);
  const [oldestRepairDays, setOldestRepairDays] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!currencyCode) {
      setIsLoading(false);
      return;
    }

    let isMounted = true;

    const fetchRepairCount = async () => {
      setIsLoading(true);
      try {
        const result = await gxDashboardPendingRepairCountApi({
          filterBy2List: [
            {
              filterKey: "CURRENCY_CODE",
              filterStringValue: currencyCode,
            },
          ],
        });
        if (isMounted) {
          setCountOfRepair(result?.data?.countOfRepair ?? 0);
          setOldestRepairDays(result?.data?.oldestRepairDays ?? 0);
        }
      } catch (error) {
        console.error("AttentionInfoCard: failed to load repair count", error);
        if (isMounted) {
          setCountOfRepair(0);
          setOldestRepairDays(0);
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchRepairCount();

    return () => {
      isMounted = false;
    };
  }, [currencyCode]);

  const headline = isLoading
    ? "Loading..."
    : `${countOfRepair} transaction${countOfRepair === 1 ? "" : "s"} in repair`;

  const description = isLoading
    ? ""
    : countOfRepair === 0
      ? "No transactions pending consent authorisation."
      : `All pending consent authorisation. Oldest is ${oldestRepairDays} day${
          oldestRepairDays === 1 ? "" : "s"
        } old.`;

  return (
    <InfoCard
      title={title || "ATTENTION"}
      color="#FF8C42"
      headline={headline}
      description={description}
    />
  );
};

export default AttentionInfoCard;